import { ArrowUpRight, MessageCircle } from "lucide-react";
import { Reveal } from "./Reveal";
import { SITE } from "../config";
import { scrollToSection } from "./Nav";

export default function CTA() {
  return (
    <section data-testid="cta-section" className="bg-ink text-ivory">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-28 md:py-40">
        <Reveal>
          <p className="text-xs sm:text-sm uppercase tracking-[0.25em] font-bold text-accent">
            Let's Talk
          </p>
          <h2 className="mt-8 font-heading font-medium tracking-tight leading-[1.02] text-[9vw] sm:text-6xl lg:text-7xl max-w-4xl">
            Have a business that deserves a <em className="italic text-accent">better</em> website?
          </h2>
          <p className="mt-8 text-base md:text-lg text-ivory/70 leading-relaxed max-w-xl">
            Tell me what you're building. I'll tell you what we can create.
          </p>
          <div className="mt-10 flex flex-wrap gap-4">
            <a
              href="#contact"
              onClick={(e) => { e.preventDefault(); scrollToSection("#contact"); }}
              data-testid="cta-cta-start-project"
              className="group inline-flex items-center gap-2 bg-ivory text-ink font-semibold tracking-wide px-8 py-4 hover:bg-accent hover:text-ivory transition-colors duration-300"
            >
              Start a Project
              <ArrowUpRight size={17} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </a>
            <a
              href={SITE.whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="cta-cta-whatsapp"
              className="inline-flex items-center gap-2 border border-ivory/30 text-ivory font-semibold tracking-wide px-8 py-4 hover:border-ivory hover:bg-ivory hover:text-ink transition-colors duration-300"
            >
              <MessageCircle size={17} />
              WhatsApp Me
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
